.chip {
  --_h: var(--h-control-md);
  --_px: var(--s-6);
  --_fs: var(--fs-xs);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--s-3);
  height: var(--_h);
  padding: 0 var(--_px);
  border-radius: var(--r-control);
  border: var(--bw-hair) solid var(--border-strong);
  background: var(--surface-card);
  color: var(--text-strong);
  font-family: var(--font-body);
  font-size: var(--_fs);
  font-weight: var(--fw-medium);
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition:
    background var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard),
    transform var(--dur-fast) var(--ease-standard);
}
.chip[data-size="sm"] {
  --_h: var(--h-control-sm);
  --_px: var(--s-5);
  --_fs: var(--fs-2xs);
}
.chip[data-selected] {
  background: var(--surface-brand-soft);
  border-color: var(--border-brand);
  color: var(--text-brand);
  font-weight: var(--fw-semibold);
}
@media (hover: hover) {
  .chip:hover:enabled:not([data-selected]) {
    border-color: var(--border-hover);
    background: var(--action-quiet-hover);
  }
}
.chip:active:enabled {
  transform: scale(0.98);
}
.chip:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
.chip:disabled {
  background: var(--control-disabled-bg);
  border-color: var(--control-disabled-border);
  color: var(--control-disabled-text);
  cursor: not-allowed;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  .chip {
    transition: none;
  }
}
